import Vue from "vue";
import VueRouter from "vue-router";

// pages

import NotFound from "../views/NotFound.vue";

import LandingPage from "../views/LandingPage.vue";

import Courses from "../views/Courses.vue";
import CoursesDetails from "../views/CoursesDetails.vue";
import CoursesContent from "../views/CoursesContent.vue";
import MyCourses from "../views/MyCourses.vue";
import ZoomLive from "../views/CourseLive.vue";

import Aboutus from "../views/Aboutus.vue";
import Contactus from "../views/Contactus.vue";

import routeAuth from "../utils/RoutingHelper.js";

import Account from "../components/auth/Account.vue";
import Login from "../views/Login.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/courses",
    name: "courses",
    component: Courses,
  },
  {
    path: "/course/:id",
    name: "course",
    component: CoursesDetails,
  },
  {
    path: "/course-content/:id",
    name: "courseContent",
    component: CoursesContent,
    meta: { requiresAuth: true, requiresLogin: true }
  },
  {
    path: "/course-content/:id/:liveid/:lessonIndex",
    name: "ZoomLive",
    component: ZoomLive,
    props: (route) => ({
      meetingId: route.params.live,
    }),
  },
  {
    path: "/my-course",
    name: "myCourses",
    component: MyCourses,
    meta: { requiresAuth: true, requiresLogin: true }
  },
  {
    path: "/",
    name: "landingPage",
    component: LandingPage,
  },
  {
    path: "/aboutus",
    name: "aboutus",
    component: Aboutus,
  },
  {
    path: "/contactus",
    name: "contactus",
    component: Contactus,
  },

  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/account",
    name: "account",
    component: Account,
  },
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Scroll to top for all routes
    if (savedPosition) {
      return savedPosition; // For back/forward navigation
    } else {
      return { x: 0, y: 0 }; // Scroll to top
    }
  },
});

// router.beforeEach(async (to, from, next) => {
//   const authStore = useAuthStore()

//   // Ensure user data is loaded
//   if (!authStore.user) {
//     await authStore.fetchUser()
//   }

//   if (to.meta.requiresAuth && !authStore.isLoggedIn) {
//     // Redirect to login if the page requires authentication
//     next('/login')
//   } else if (to.meta.requiresPayment && !authStore.isPaid) {
//     // Redirect to dashboard if the page requires payment but the user isn't subscribed
//     next('/dashboard')
//   } else {
//     next()
//   }
// })

export default router;
